import { useContext } from 'react'

import { ScrollViewPositionContext } from './scroll-view-position-context'
import type { ScrollViewPositionRef } from './scroll-view-position-context'

export function useScrollViewPosition(): ScrollViewPositionRef | null {
  return useContext(ScrollViewPositionContext)
}
